import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { usePermission } from "./usePermission";

interface PermissionGateProps {
  permission?: string;
  anyPermission?: string[];
  role?: string;
  roles?: string[];
  redirectTo?: string;
  children: ReactNode;
}

/**
 * Route protection wrapper (RBACStack pattern).
 * If permission check fails, redirects or renders an access denied banner.
 */
export function PermissionGate({
  permission,
  anyPermission,
  role,
  roles,
  redirectTo = "/",
  children,
}: PermissionGateProps) {
  const { hasPermission, hasAnyPermission, hasRole, role: currentRole } = usePermission();

  const allowed =
    (!permission || hasPermission(permission)) &&
    (!anyPermission || hasAnyPermission(anyPermission)) &&
    (!role || hasRole(role)) &&
    (!roles || (currentRole && roles.includes(currentRole)));

  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
